import React, { useEffect, useState } from "react";
import Nav from "./components/nav";
import DashBorad from "./components/dashboard/dashboard";
import { useAppSelector } from "./app/hooks";
import { selectPlaying } from "./features/audio";
import { audioElement, setWechatFont } from "./utils/util";
import Card from "./components/card";
import RewardHistory from "./components/reward-history";
import JicFloatingWidget from "./components/jicFloatingWidget";
import FaceProfile from "./components/faceProfile";
import FaceScanner from "./components/faceScanner";
import { fetchJicHandle, getJicToken, getJicUser, loginJic } from "./lib/jic";

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, "").toLowerCase();

  if (path === "/trade") {
    return <LegacyFaceApp />;
  }

  if (path === "/me") {
    return <MyFaceRedirect />;
  }

  const handle = path.slice(1);
  if (/^[a-z0-9_]{1,32}$/.test(handle)) {
    return <FaceProfile handle={handle} />;
  }

  return <FaceScanner />;
}

// /me:登录 JIC → 查自己的短名字 → 跳到 face.jic.io/<name> 认领页
function MyFaceRedirect() {
  const [message, setMessage] = useState("正在识别你的 JIC 身份…");

  useEffect(() => {
    const user = getJicUser();
    if (!user?.sub || !getJicToken()) {
      loginJic({ clearLocal: false });
      return;
    }
    fetchJicHandle(user.sub).then((name) => {
      if (name) {
        window.location.replace(`/${name}`);
      } else {
        setMessage("这个账户还没有 JIC 短名字，先到 u.jic.io 认领一个，再回来绑定人脸。");
      }
    });
  }, []);

  return (
    <main className="face3-page">
      <header className="face3-header">
        <a className="face3-brand" href="/" aria-label="FACE3 home"><span className="face3-mark">F³</span><span>FACE3</span></a>
      </header>
      <section className="face3-scan-hero">
        <div className="face3-scan-copy">
          <h1>绑定我的脸</h1>
          <p>{message}</p>
          <div className="face3-scan-actions">
            <a href="https://u.jic.io/u"><button type="button">去 u.jic.io 拿短名字</button></a>
          </div>
        </div>
      </section>
      <JicFloatingWidget />
    </main>
  );
}

function LegacyFaceApp() {
  useEffect(() => {
    setWechatFont();
  }, []);

  const [tab, setTab] = useState("home");
  const [displayNav, setDisplayNav] = useState(true);

  const isPlaying = useAppSelector(selectPlaying);

  useEffect(() => {
    document.addEventListener("click", (e) => {
      setDisplayNav(false);
    });
  }, []);

  function playMusic() {
    return;
  }
  useEffect(() => {
    if (isPlaying) {
      audioElement?.addEventListener(
        "ended",
        () =>
          audioElement
            .play()
            .catch((e) => console.log("Failed to play music,error:", e)),
        false
      );
    }
  }, [isPlaying]);

  return (
    <div
      onMouseEnter={playMusic}
      className="select-none absolute top-0 w-full  h-full min-h-max flex flex-col items-center bg-cover overflow-hidden"
      style={{ backgroundImage: `url('/assets/b1.jpg')` }}
    >
      <Nav
        displayNav={displayNav}
        setDisplayNav={setDisplayNav}
        setTab={setTab}
      ></Nav>
      {tab === "home" && <Card />}

      {tab === "dashboard" && <DashBorad></DashBorad>}
      {tab === "reward" && <RewardHistory></RewardHistory>}
      <JicFloatingWidget />
    </div>
  );
}
